import { message } from 'antd'
import { action, makeObservable, observable, runInAction } from 'mobx'
import { APIResponse, fetchWithToken } from '../../utils/fetch'
import { getHistory } from '../../utils/history'
import Application from '../../interfaces/ISummaryProfile'
import { INTERVIEW_ANNOUNCEMENT_OPEN } from '../../utils/const'

class ApplicationStore {
  @observable loading: boolean = false
  @observable formData: object = {}

  constructor() {
    makeObservable(this)
  }

  @action
  async getAnswers() {
    try {
      this.loading = true
      const result = await fetchWithToken<APIResponse<Application>>(
        'registration/application',
        {},
        'GET'
      )

      if (result.status === 'success') {
        if (INTERVIEW_ANNOUNCEMENT_OPEN) {
          getHistory().push('/announcement/interview')
          return
        } else if (result.payload.status === 'completed') {
          getHistory().push('/step/submitted')
          return
        }
        runInAction(() => (this.formData = result.payload))
      }
    } catch (error) {
      console.error(error)
      message.error('มีข้อผิดพลาดเกิดขึ้น กรุณาลองอีกครั้ง')
    } finally {
      this.loading = false
    }
  }

  @action
  handleSave(data: object): Promise<void> {
    return new Promise(async (resolve, reject) => {
      try {
        this.loading = true
        const result = await fetchWithToken(
          'registration/application/profile/save',
          data,
          'PUT'
        )
        if (result.status === 'success') {
          if (resolve) {
            resolve()
          }
        }
      } catch (error) {
        if (reject) {
          reject()
        }
      } finally {
        this.loading = false
      }
    })
  }

  async handleSubmitProfile(data: object, onSuccess?: () => void) {
    try {
      this.loading = true
      const result = await fetchWithToken(
        'registration/application/profile/submit',
        data,
        'PUT'
      )
      if (result.status === 'success' && onSuccess) {
        onSuccess()
      }
    } catch (error) {
      console.error(error)
      message.error('มีข้อผิดพลาดเกิดขึ้น กรุณาลองอีกครั้ง')
    } finally {
      this.loading = false
    }
  }

  async handleSubmit(data: object, onSuccess?: () => void) {
    try {
      this.loading = true
      const result = await fetchWithToken(
        'registration/application/submit',
        data,
        'PUT'
      )
      if (result.status === 'success' && onSuccess) {
        onSuccess()
      }
    } catch (error) {
      console.error(error)
      message.error('มีข้อผิดพลาดเกิดขึ้น กรุณาลองอีกครั้ง')
    } finally {
      this.loading = false
    }
  }
}
const applicationStore = new ApplicationStore()
export default applicationStore
